import {
  LOADING,
  PUBLIC_MEETING_LINKS,
} from "../actionType/publicMeetingLinkType";
import { publicMeetingLinks } from "../constant/Constant";
import {
  deleteAuthMethod,
  getAuthMethod,
  postAuthMethod,
  putAuthMethod,
} from "../services/HttpServices";

export const createPublicMeetingLink = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return postAuthMethod(publicMeetingLinks, payload)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const updatePublicMeetingLink = (id, payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return putAuthMethod(publicMeetingLinks, id, payload)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const getPublicMeetingLinks = () => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });

  return getAuthMethod(publicMeetingLinks)
    .then((res) => {
      dispatch({
        type: PUBLIC_MEETING_LINKS,
        payload: res?.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      if (!err?.response?.data) return;
      return err;
    });
};

export const deletePublicMeetingLink = (id) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return deleteAuthMethod(`${publicMeetingLinks}/${id}`)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};
